import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { PageHeadComponent } from './components/core/page-head/page-head.component';
import { HeaderComponent } from './components/core/header/header.component';
import { Http, RequestOptions, HttpModule } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { NguiDatetimePickerModule } from '@ngui/datetime-picker';

import { NullDefaultValueDirective } from './directives/listeners/null-default-value.directive';
import { IsSuperAdminDirective } from './directives/permissions/is-super-admin.directive';
import { NotificationsService } from 'angular2-notifications';
import { Api, NoAuthApi } from './services/api.service';
import { UserService } from './services/user.service';
import { SubscriptionOfferService } from './services/subscription-offer.service';
import { RetailerService } from './services/retailer.service';
import { TrackerStatusService } from './services/trackerstatus.service';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './components/pages/login/login.component';
import { FormsModule } from '@angular/forms';
import { MenuComponent } from './components/core/menu/menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './services/auth.service';
import { PaginationComponent } from './components/core/pagination/pagination.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard.component';
import { DashboardAdminComponent } from './components/pages/dashboard/admin/dashboard-admin.component';
import { DashboardChurnComponent } from './components/pages/dashboard/churn/dashboard-churn.component';
import { DashboardSubscriptionComponent } from './components/pages/dashboard/subscription/dashboard-subscription.component';
import {
  DashboardSubscriptionCountComponent
} from './components/pages/dashboard/subscription-count/dashboard-subscription-count.component';
import { DashboardOptionComponent } from './components/pages/dashboard/option/dashboard-option.component';
import { DashboardGroupedByDateComponent } from './components/pages/dashboard/groupedbydate/dashboard-groupedbydate.component';
import { DashboardSponsoringComponent } from './components/pages/dashboard/sponsoring/dashboard-sponsoring.component';
import { DashboardMiscComponent } from './components/pages/dashboard/misc/dashboard-misc.component';
import {
  NbAverageTrackerPerUserComponent
} from './components/pages/dashboard/misc/nb-average-tracker-per-user/nb-average-tracker-per-user.component';
import {
  ListAverageLengthSubscriptionComponent
} from './components/pages/dashboard/misc/list-average-length-subscription/list-average-length-subscription.component';
import {
  ListMonthlyCohortsComponent
} from './components/pages/dashboard/misc/list-monthly-cohorts/list-monthly-cohorts.component';
import {
  AverageLengthCancelledSubscriptionComponent
} from './components/pages/dashboard/misc/average-length-cancelled-subscription/average-length-cancelled-subscription.component';
import {
  AverageLengthActiveSubscriptionComponent
} from './components/pages/dashboard/misc/average-length-active-subscription/average-length-active-subscription.component';
import {
  MonthlyCohortsComponent
} from './components/pages/dashboard/misc/monthly-cohorts/monthly-cohorts.component';
import { TrackerStatusIdToNamePipe } from './pipes/trackerstatus-id-to-name.pipe';
import { LocalCache } from './utils/local-cache.utils';
import { AuthGuard } from './auth-guard.service';
import { UserSelectComponent } from './components/shared/user-select/user-select.component';
import { OtaDetailComponent } from './components/pages/ota/ota-detail.component';
import { TrackerService } from './services/tracker.service';
import { TrackerB2bService } from './services/tracker-b2b.service';
import { TrackerListComponent } from './components/pages/tracker/tracker-list.component';
import { TrackerB2bListComponent } from './components/pages/tracker/tracker-b2b-list.component';
import { TrackerDetailComponent } from './components/pages/tracker/tracker-detail.component';
import { SubscriptionService } from './services/subscription.service';
import { LinkedSubscriptionsComponent } from './components/blocks/linked-subscriptions/linked-subscriptions.component';
import { LinkedTrackersComponent } from './components/blocks/linked-trackers/linked-trackers.component';
import { AccountOptionComponent } from './components/blocks/linked-account-options/linked-account-options.component';
import { OptionInformationComponent } from './components/blocks/option-information/option-information.component';
import { PushService } from './services/push.service';
import { PushNotificationComponent } from './components/blocks/push-notification/push-notification.component';
import { SubscriptionInformationComponent } from './components/blocks/subscription-information/subscription-information.component';
import { SubscriptionHistoryComponent } from './components/blocks/subscription-history/subscription-history.component';
import { TrackerAdminService } from './services/trackeradmin.service';
import { TrackerAdminComponent } from './components/blocks/tracker-admin/tracker-admin.component';
import { TrackerInformationComponent } from './components/blocks/tracker-information/tracker-information.component';
import { TrackerInformationAdminComponent } from './components/blocks/tracker-information/tracker-information-admin.component';
import { TrackerOwnerComponent } from './components/blocks/tracker-owner/tracker-owner.component';
import { TrackerPositionComponent } from './components/blocks/tracker-position/tracker-position.component';
import { UserCommentService } from './services/usercomment.service';
import { UserCommentsComponent } from './components/blocks/user-comments/user-comments.component';
import { SubscriptionAmountPipe } from './pipes/subscription-amount.pipe';
import { IsoDateToStringPipe } from './pipes/iso-date-to-string.pipe';
import { IsoDateToExpirationFormatPipe } from './pipes/iso-date-to-expiration-format.pipe';
import { OptionAmountPipe } from './pipes/option-amount.pipe';
import { TaskService } from './services/task.service';
import { TrackeradminListComponent } from './components/pages/trackeradmin/trackeradmin-list.component';
import { ActivationService } from './services/activation.service';
import { TrackeradminDetailComponent } from './components/pages/trackeradmin/trackeradmin-detail.component';
import { IsActiveTrackerPipe } from './pipes/is-active-tracker.pipe';
import { RefuelSmsService } from './services/refuelsms.service';
import { RefuelSmsListComponent } from './components/pages/refuelsms/refuelsms-list.component';
import { TrackerStatusListComponent } from './components/pages/trackerstatus/trackerstatus-list.component';
import { TimezoneService } from './services/timezones.service';
import { UserConnectComponent } from './components/pages/user/user-connect.component';
import { UserDetailComponent } from './components/pages/user/user-detail.component';
import { UserListComponent } from './components/pages/user/user-list.component';
import { UseradminListComponent } from './components/pages/useradmin/useradmin-list.component';
import { SubscriptionDetailComponent } from './components/pages/subscription/subscription-detail.component';
import { SubscriptionListComponent } from './components/pages/subscription/subscription-list.component';
import { SubscriptionPaymentService } from './services/subscription-payment.service';
import { TaskDetailComponent } from './components/pages/task/task-detail.component';
import { TaskListComponent } from './components/pages/task/task-list.component';
import { AlertListComponent } from './components/pages/alert/alert-list.component';
import { PositionListComponent } from './components/pages/position/position-list.component';
import { BoxCollapseDirective } from './directives/boxcollapse/box-collapse.directive';
import {
  DashboardOptionGroupedByDateComponent
} from './components/pages/dashboard/optiongroupedbydate/dashboard-optiongroupedbydate.component';
import { WhiteLabelService } from './services/white-label.service'
import { TrackerFilterComponent } from './components/blocks/tracker-filter/tracker-filters.component';
import { UserFilterComponent } from './components/blocks/user-filter/user-filters.component';
import { OptionPaymentService } from './services/option-payment.service';

export function authHttpServiceFactory(authConfig: AuthConfig, http: Http, options: RequestOptions) {
  return new AuthHttp(authConfig, http, options);
}

@NgModule({
  declarations: [
    AppComponent,

    // core
    HeaderComponent,
    PageHeadComponent,
    MenuComponent,
    LoginComponent,
    PaginationComponent,

    // shared
    UserSelectComponent,

    // blocks
    AccountOptionComponent,
    LinkedSubscriptionsComponent,
    LinkedTrackersComponent,
    OptionInformationComponent,
    PushNotificationComponent,
    SubscriptionInformationComponent,
    SubscriptionHistoryComponent,
    TrackerAdminComponent,
    TrackerInformationComponent,
    TrackerInformationAdminComponent,
    TrackerOwnerComponent,
    TrackerPositionComponent,
    UserCommentsComponent,
    TrackerFilterComponent,
    UserFilterComponent,

    // pages/dashboard
    DashboardComponent,
    DashboardAdminComponent,
    DashboardGroupedByDateComponent,
    DashboardChurnComponent,
    DashboardSubscriptionComponent,
    DashboardSubscriptionCountComponent,
    DashboardOptionComponent,
    DashboardOptionGroupedByDateComponent,
    DashboardMiscComponent,
    NbAverageTrackerPerUserComponent,
    ListAverageLengthSubscriptionComponent,
    ListMonthlyCohortsComponent,
    AverageLengthCancelledSubscriptionComponent,
    AverageLengthActiveSubscriptionComponent,
    MonthlyCohortsComponent,
    DashboardSponsoringComponent,

    // pages/ota
    OtaDetailComponent,

    // pages/tracker
    TrackerListComponent,
    TrackerB2bListComponent,
    TrackerDetailComponent,

    // pages/trackeradmin
    TrackeradminListComponent,
    TrackeradminDetailComponent,

    // pages/trackerstatus
    TrackerStatusListComponent,

    // pages/refuelsms
    RefuelSmsListComponent,

    // pages/user
    UserListComponent,

    // pages/user & pages/useradmin
    UserConnectComponent, 
    UserDetailComponent,  

    // pages/useradmin
    UseradminListComponent,
    

    // pages/subscription
    SubscriptionDetailComponent,
    SubscriptionListComponent,

    // pages/task
    TaskDetailComponent,
    TaskListComponent,

    // pages/alert
    AlertListComponent,

    // pages/position
    PositionListComponent,

    // Directive
    IsSuperAdminDirective,
    NullDefaultValueDirective,
    BoxCollapseDirective,

    // Pipes
    TrackerStatusIdToNamePipe,
    SubscriptionAmountPipe,
    IsoDateToExpirationFormatPipe,
    IsoDateToStringPipe,
    OptionAmountPipe,
    IsActiveTrackerPipe,
  ],
  providers: [
    {
      provide: AuthConfig,
      useFactory: () => {
        return new AuthConfig({
          headerPrefix: 'JWT',
          globalHeaders: [{'Accept': 'application/json'}]
        });
      }
    },
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [AuthConfig, Http, RequestOptions]
    },
    ActivationService,
    Api,
    AuthGuard,
    AuthService,
    LocalCache,
    NoAuthApi,
    NotificationsService,
    PushService,
    RefuelSmsService,
    RetailerService,
    SubscriptionOfferService,
    SubscriptionPaymentService,
    OptionPaymentService,
    SubscriptionService,
    TaskService,
    TimezoneService,
    TrackerAdminService,
    TrackerB2bService,
    TrackerService,
    TrackerStatusService,
    UserCommentService,
    UserService,
    WhiteLabelService
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    SimpleNotificationsModule.forRoot(),
    NguiDatetimePickerModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /app/src/app/app.module.ts